import { ActionType } from '../constants/trade.constant';
import { Stock, StockDropDownOption, StockOnHand } from '../models/stock';

export const DUMMY_STOCKS: Stock[] = [
  {
    id: '1',
    ticker: 'AAPL',
    name: 'Apple Inc.',
    sector: 'Technology',
    industry: 'Consumer Electronics',
    currentPrice: 150.12,
    dailyHigh: 152.0,
    dailyLow: 149.2,
    volume: 5000000,
    averageVolume: 5600000,
    marketCap: 2400000000000,
    description:
      'Apple Inc. designs, manufactures, and markets smartphones, personal computers, tablets, wearables, and accessories worldwide.',
    country: 'United States',
  },
  {
    id: '2',
    ticker: 'MSFT',
    name: 'Microsoft Corporation',
    sector: 'Technology',
    industry: 'Software',
    currentPrice: 300.5,
    dailyHigh: 305.0,
    dailyLow: 295.0,
    volume: 4000000,
    averageVolume: 4500000,
    marketCap: 2200000000000,
    description:
      'Microsoft Corporation develops, licenses, and supports software, services, devices, and solutions worldwide.',
    country: 'United States',
  },
  {
    id: '3',
    ticker: 'AMZN',
    name: 'Amazon.com, Inc.',
    sector: 'Consumer Cyclical',
    industry: 'Internet Retail',
    currentPrice: 3400.0,
    dailyHigh: 3450.0,
    dailyLow: 3350.0,
    volume: 4500000,
    averageVolume: 4700000,
    marketCap: 1700000000000,
    description:
      'Amazon.com, Inc. engages in the retail sale of consumer products and subscriptions in North America and internationally.',
    country: 'United States',
  },
  {
    id: '4',
    ticker: 'GOOG',
    name: 'Alphabet Inc.',
    sector: 'Communication Services',
    industry: 'Internet Content & Information',
    currentPrice: 2700.0,
    dailyHigh: 2750.0,
    dailyLow: 2650.0,
    volume: 2000000,
    averageVolume: 2200000,
    marketCap: 1800000000000,
    description:
      'Alphabet Inc. provides online advertising services in the United States, Europe, the Middle East, Africa, the Asia-Pacific, Canada, and Latin America.',
    country: 'United States',
  },
  {
    id: '5',
    ticker: 'FB',
    name: 'Facebook, Inc.',
    sector: 'Communication Services',
    industry: 'Internet Content & Information',
    currentPrice: 350.65,
    dailyHigh: 355.0,
    dailyLow: 348.0,
    volume: 3000000,
    averageVolume: 3200000,
    marketCap: 1000000000000,
    description:
      'Facebook, Inc. develops products that enable people to connect and share with friends and family through mobile devices, personal computers, virtual reality headsets, and in-home devices worldwide.',
    country: 'United States',
  },
  {
    id: '6',
    ticker: 'TSLA',
    name: 'Tesla, Inc.',
    sector: 'Consumer Cyclical',
    industry: 'Auto Manufacturers',
    currentPrice: 600.1,
    dailyHigh: 605.0,
    dailyLow: 590.0,
    volume: 8000000,
    averageVolume: 8500000,
    marketCap: 600000000000,
    description:
      'Tesla, Inc. designs, develops, manufactures, leases, and sells electric vehicles, and energy generation and storage systems in the United States, China, and internationally.',
    country: 'United States',
  },
  {
    id: '7',
    ticker: 'NVDA',
    name: 'NVIDIA Corporation',
    sector: 'Technology',
    industry: 'Semiconductors',
    currentPrice: 700.0,
    dailyHigh: 705.0,
    dailyLow: 695.0,
    volume: 7000000,
    averageVolume: 7100000,
    marketCap: 450000000000,
    description:
      'NVIDIA Corporation operates as a visual computing company worldwide.',
    country: 'United States',
  },
  {
    id: '8',
    ticker: 'JPM',
    name: 'JPMorgan Chase & Co.',
    sector: 'Financial Services',
    industry: 'Banks—Diversified',
    currentPrice: 100.0,
    dailyHigh: 102.0,
    dailyLow: 98.0,
    volume: 20000000,
    averageVolume: 21000000,
    marketCap: 400000000000,
    description:
      'JPMorgan Chase & Co. operates as a financial services company worldwide.',
    country: 'United States',
  },
  {
    id: '9',
    ticker: 'V',
    name: 'Visa Inc.',
    sector: 'Financial Services',
    industry: 'Credit Services',
    currentPrice: 200.0,
    dailyHigh: 205.0,
    dailyLow: 198.0,
    volume: 6000000,
    averageVolume: 6500000,
    marketCap: 500000000000,
    description:
      'Visa Inc. operates as a payments technology company worldwide.',
    country: 'United States',
  },
  {
    id: '10',
    ticker: 'PYPL',
    name: 'PayPal Holdings, Inc.',
    sector: 'Financial Services',
    industry: 'Credit Services',
    currentPrice: 250.0,
    dailyHigh: 255.0,
    dailyLow: 245.0,
    volume: 5000000,
    averageVolume: 5200000,
    marketCap: 350000000000,
    description:
      'PayPal Holdings, Inc. operates as a technology platform and digital payments company that enables digital and mobile payments on behalf of consumers and merchants worldwide.',
    country: 'United States',
  },
  {
    id: '11',
    ticker: 'ADBE',
    name: 'Adobe Inc.',
    sector: 'Technology',
    industry: 'Software—Infrastructure',
    currentPrice: 500.0,
    dailyHigh: 505.0,
    dailyLow: 495.0,
    volume: 2000000,
    averageVolume: 2200000,
    marketCap: 250000000000,
    description:
      'Adobe Inc. operates as a diversified software company worldwide.',
    country: 'United States',
  },
  {
    id: '12',
    ticker: 'INTC',
    name: 'Intel Corporation',
    sector: 'Technology',
    industry: 'Semiconductors',
    currentPrice: 50.0,
    dailyHigh: 52.0,
    dailyLow: 48.0,
    volume: 10000000,
    averageVolume: 10500000,
    marketCap: 220000000000,
    description:
      'Intel Corporation designs, manufactures, and sells essential technologies for the cloud, smart, and connected devices for retail, industrial, and consumer uses worldwide.',

    country: 'United States',
  },
  {
    id: '13',
    ticker: 'NFLX',
    name: 'Netflix, Inc.',
    sector: 'Communication Services',
    industry: 'Entertainment',
    currentPrice: 550.0,
    dailyHigh: 560.0,
    dailyLow: 540.0,
    volume: 3000000,
    averageVolume: 3200000,
    marketCap: 250000000000,
    description:
      'Netflix, Inc. provides subscription streaming entertainment service.',

    country: 'United States',
  },
  {
    id: '14',
    ticker: 'DIS',
    name: 'The Walt Disney Company',
    sector: 'Communication Services',
    industry: 'Entertainment',
    currentPrice: 180.0,
    dailyHigh: 185.0,
    dailyLow: 175.0,
    volume: 5000000,
    averageVolume: 5300000,
    marketCap: 320000000000,
    description:
      'The Walt Disney Company, together with its subsidiaries, operates as an entertainment company worldwide.',

    country: 'United States',
  },
  {
    id: '15',
    ticker: 'BA',
    name: 'The Boeing Company',
    sector: 'Industrials',
    industry: 'Aerospace & Defense',
    currentPrice: 220.0,
    dailyHigh: 225.0,
    dailyLow: 215.0,
    volume: 4000000,
    averageVolume: 4200000,
    marketCap: 130000000000,
    description:
      'The Boeing Company, together with its subsidiaries, designs, develops, manufactures, sales, services, and supports commercial jetliners, military aircraft, satellites, missile defense, human space flight and launch systems, and services worldwide.',

    country: 'United States',
  },
  {
    id: '16',
    ticker: 'MCD',
    name: "McDonald's Corporation",
    sector: 'Consumer Cyclical',
    industry: 'Restaurants',
    currentPrice: 240.0,
    dailyHigh: 245.0,
    dailyLow: 235.0,
    volume: 3000000,
    averageVolume: 3200000,
    marketCap: 180000000000,
    description:
      "McDonald's Corporation operates and franchises McDonald's restaurants in the United States and internationally.",
    country: 'United States',
  },
  {
    id: '17',
    ticker: 'KO',
    name: 'The Coca-Cola Company',
    sector: 'Consumer Defensive',
    industry: 'Beverages—Non-Alcoholic',
    currentPrice: 55.0,
    dailyHigh: 57.0,
    dailyLow: 53.0,
    volume: 8000000,
    averageVolume: 8300000,
    marketCap: 230000000000,
    description:
      'The Coca-Cola Company, a beverage company, manufactures, markets, and sells various nonalcoholic beverages worldwide.',

    country: 'United States',
  },
  {
    id: '18',
    ticker: 'PEP',
    name: 'PepsiCo, Inc.',
    sector: 'Consumer Defensive',
    industry: 'Beverages—Non-Alcoholic',
    currentPrice: 150.0,
    dailyHigh: 155.0,
    dailyLow: 145.0,
    volume: 4000000,
    averageVolume: 4200000,
    marketCap: 200000000000,
    description:
      'PepsiCo, Inc. operates as a food and beverage company worldwide.',
    country: 'United States',
  },
  {
    id: '19',
    ticker: 'PFE',
    name: 'Pfizer Inc.',
    sector: 'Healthcare',
    industry: 'Drug Manufacturers—General',
    currentPrice: 40.0,
    dailyHigh: 42.0,
    dailyLow: 38.0,
    volume: 20000000,
    averageVolume: 21000000,
    marketCap: 220000000000,
    description:
      'Pfizer Inc. discovers, develops, manufactures, markets, distributes, and sells biopharmaceutical products worldwide.',
    country: 'United States',
  },
  {
    id: '20',
    ticker: 'JNJ',
    name: 'Johnson & Johnson',
    sector: 'Healthcare',
    industry: 'Drug Manufacturers—General',
    currentPrice: 170.0,
    dailyHigh: 175.0,
    dailyLow: 165.0,
    volume: 6000000,
    averageVolume: 6500000,
    marketCap: 390000000000,
    description:
      'Johnson & Johnson researches and develops, manufactures, and sells various products in the health care field worldwide.',
    country: 'United States',
  },
];

export const DUMMY_STOCKS_ON_HAND: StockOnHand[] = [
  {
    ticker: 'AAPL',
    company: 'Apple Inc.',
    quantity: 50,
    averagePrice: 145.6,
    action: ActionType.Long,
    industry: 'Information Technology',
  },
  {
    ticker: 'MSFT',
    company: 'Microsoft Corporation',
    quantity: 30,
    averagePrice: 301.5,
    action: ActionType.Short,
    industry: 'Information Technology',
  },
  {
    ticker: 'AMZN',
    company: 'Amazon.com, Inc.',
    quantity: 10,
    averagePrice: 3322.0,
    action: ActionType.Long,
    industry: 'Consumer Discretionary',
  },
  {
    ticker: 'GOOG',
    company: 'Alphabet Inc.',
    quantity: 15,
    averagePrice: 2721.88,
    action: ActionType.Short,
    industry: 'Communication Services',
  },
  {
    ticker: 'FB',
    company: 'Facebook, Inc.',
    quantity: 40,
    averagePrice: 359.0,
    action: ActionType.Long,
    industry: 'Communication Services',
  },
];

export const DUMMY_STOCK_DROPDOWN_MENU: StockDropDownOption[] = [
  {
    ticker: 'AAPL',
    company: 'Apple Inc.',
  },
  {
    ticker: 'MSFT',
    company: 'Microsoft Corporation',
  },
  {
    ticker: 'AMZN',
    company: 'Amazon.com, Inc.',
  },
  {
    ticker: 'GOOG',
    company: 'Alphabet Inc.',
  },
  {
    ticker: 'FB',
    company: 'Facebook, Inc.',
  },
  {
    ticker: 'TSLA',
    company: 'Tesla, Inc.',
  },
  {
    ticker: 'NVDA',
    company: 'Nvidia Corporation',
  },
  {
    ticker: 'JPM',
    company: 'JPMorgan Chase & Co.',
  },
  {
    ticker: 'V',
    company: 'Visa Inc.',
  },
  {
    ticker: 'PYPL',
    company: 'PayPal Holdings, Inc.',
  },
  {
    ticker: 'ADBE',
    company: 'Adobe Inc.',
  },
  {
    ticker: 'INTC',
    company: 'Intel Corporation',
  },
  {
    ticker: 'NFLX',
    company: 'Netflix, Inc.',
  },
  {
    ticker: 'DIS',
    company: 'The Walt Disney Company',
  },
  {
    ticker: 'BA',
    company: 'The Boeing Company',
  },
  {
    ticker: 'MCD',
    company: "McDonald's Corporation",
  },
  {
    ticker: 'KO',
    company: 'The Coca-Cola Company',
  },
  {
    ticker: 'PEP',
    company: 'PepsiCo, Inc.',
  },
  {
    ticker: 'PFE',
    company: 'Pfizer Inc.',
  },
  {
    ticker: 'JNJ',
    company: 'Johnson & Johnson',
  },
];
